/* import firebase from 'firebase';

const config = {
    apiKey: "AIzaSyDwHO1Kd5Mmm20kmIMDCp2VKHy1qW6mOZY",
    authDomain: "anders-28b35.firebaseapp.com",
    databaseURL: "https://anders-28b35.firebaseio.com",
    projectId: "anders-28b35",
    storageBucket: "anders-28b35.appspot.com",
    messagingSenderId: "406930018036",
    appId: "1:406930018036:web:4c864f201dc2da8a25d8a1"
  };
  firebase.initializeApp(config);
  export const auth = firebase.auth();
  export const db = firebase.database();
  export const fstore = firebase.firestore();
  export const storage = firebase.storage();
 */


// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyDwHO1Kd5Mmm20kmIMDCp2VKHy1qW6mOZY",
  authDomain: "anders-28b35.firebaseapp.com",
  databaseURL: "https://anders-28b35.firebaseio.com",
  projectId: "anders-28b35",
  storageBucket: "anders-28b35.appspot.com",
  messagingSenderId: "406930018036",
  appId: "1:406930018036:web:4c864f201dc2da8a25d8a1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const fstore = getFirestore(app);

export const baseUrl = '/'

export default app 

      
    